export default __webpack_public_path__ + "static/media/videocam_black.7e57e748.svg";